import { Injectable } from '@angular/core';
import { ImageryProjectService } from './project';
@Injectable()
export class ImageryService{
    constructor(
        public project: ImageryProjectService){}
}